const authHeader = (accessToken) => {
  const user = accessToken;
  if (user) {
    // const decodedJwt = jwt_decode(user);
  }

  // const user = AppContext._currentValue?.loginUserDetails?.token;
  if (user) {
    return { Authorization: "Bearer " + user, "Content-Type": "application/json" };
    // return "Bearer ";
  } else {
    return {};
  }
};
export default authHeader;

// https://bezkoder.com/react-hooks-redux-login-registration-example/
